import React, { useState, useEffect } from "react";
import "./nav.css";
import { AiOutlineHome, AiOutlineUser } from "react-icons/ai";
import { BiBook } from "react-icons/bi";
import { HiOutlineFolderOpen } from "react-icons/hi";

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#");

  useEffect(() => {
    const sections = document.querySelectorAll("section");
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveNav(`#${entry.target.id}`);
          }
        });
      },
      { threshold: 0.5 } 
    );

    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <nav>
      <a href="#header" className={activeNav === "#header" ? "active" : ""}>
        <AiOutlineHome />
      </a>
      <a href="#about" className={activeNav === "#about" ? "active" : ""}>
        <AiOutlineUser />
      </a>
      <a href="#wexperience" className={activeNav === "#wexperience" ? "active" : ""}>
        <BiBook />
      </a>
      <a href="#experience" className={activeNav === "#experience" ? "active" : ""}>
        <HiOutlineFolderOpen />
      </a>
    </nav>
  );
};

export default Nav;
